/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";
import moment from 'moment';
import { isMobile } from 'react-device-detect';

class VoteSch2025 extends PureComponent {
  state = {
    slideIndex: 1,
    slidePlay: true,
    gap: 0,
    voteList: [
      {
        part: '1차 예선',
        dateTitle: '11.19 - 11.24',
        title: '분기별 예선전',
        title1: '(분기별 작품 투표)',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2025-11-19 16:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2025-11-19 16:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2025-11-24 16:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {
        part: '2차 예선',
        dateTitle: '11.26 - 12.01',
        title: '후보별 2차 예선',
        title1: '(16개조, 1, 2등 선발)',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2025-11-26 16:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2025-11-26 16:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2025-12-01 16:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {
        part: '32강',
        dateTitle: '12.03 - 12.08',
        title: '후보별 32강전',
        title1: '(4캐릭터 x 8개조)',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2025-12-03 16:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2025-12-03 16:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2025-12-08 16:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {
        part: '16강',
        dateTitle: '12.10 - 12.15',
        title: '후보별 16강전',
        title1: '(4캐릭터 x 4개조)',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2025-12-10 16:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2025-12-10 16:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2025-12-15 16:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {
        part: '8강',
        dateTitle: '12.17 - 12.22',
        title: '후보별 8강전',
        title1: '(2캐릭터 x 4개조)',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2025-12-17 16:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2025-12-17 16:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2025-12-22 12:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {
        part: '4강',
        dateTitle: '12.22 - 12.26',
        title: '후보별 4강전',
        title1: '(2캐릭터 x 2개조)',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2025-12-22 18:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2025-12-22 18:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2025-12-26 12:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {
        part: '3, 4위전',
        dateTitle: '12.26 - 12.29',
        title: '준결승전',
        title1: '후보별 준결승전',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2025-12-26 18:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2025-12-26 18:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2025-12-29 12:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {
        part: '결승전',
        dateTitle: '12.26 - 12.29',
        title: '결승전',
        title1: '후보별 결승전',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2025-12-26 18:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2025-12-26 18:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2025-12-29 12:00:00'
            ? '투표하기'
            : '결과보기',
      },
    ],
    slide: isMobile ? 210 * 0 : 250 * 0, // 숫자변경.)-1씩
  };
  voteUrl = 'https://aketo.aniplustv.com';
  componentDidMount = () => {
    console.log('did mount');

    const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    if (today >= '2025-11-19 16:00:00' && today < '2025-11-26 16:00:00') {
      this.setState({
        gap: 0,
        slide: isMobile ? 210 * 0 : 250 * 0,
      });
    } else if (
      today >= '2025-11-26 16:00:00' &&
      today < '2025-12-03 16:00:00'
    ) {
      this.setState({
        gap: 1,
        slide: isMobile ? 210 * -1 : 250 * -1,
      });
    } else if (
      today >= '2025-12-03 16:00:00' &&
      today < '2025-12-10 16:00:00'
    ) {
      this.setState({
        gap: 2,
        slide: isMobile ? 210 * -2 : 250 * -2,
      });
    } else if (
      today >= '2025-12-10 16:00:00' &&
      today < '2025-12-17 16:00:00'
    ) {
      this.setState({
        gap: 3,
        slide: isMobile ? 210 * -3 : 250 * -3,
      });
    } else if (today >= '2025-12-17 16:00:00') {
      this.setState({
        gap: 4,
        slide: isMobile ? 210 * -4 : 250 * -4,
      });
    }
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return this.props.childProps.i !== nextProps.childProps.i;
    //return false;
  };
  componentWillReceiveProps = (nextProps) => {
    //console.log(this.props.childProps.i, nextProps.childProps.i)
    if (this.props.childProps.i !== nextProps.childProps.i) {
    } else {
    }
  };

  _onNext = () => {
    //this.slider.slickNext()
    //console.log('next')
    const { slide, slideIndex } = this.state;
    if (slideIndex >= 5) {
    } else {
      this.setState({
        slide: isMobile ? slide - 189 : slide - 250 * 2,
        slideIndex: slideIndex + 1,
      });
    }

    console.log(slide, slideIndex);
  };
  _onPrev = () => {
    //this.slider.slickPrev()
    const { slide, slideIndex } = this.state;
    console.log('prev');
    console.log(slideIndex);

    if (slideIndex < 0) {
    } else {
      this.setState({
        slide: isMobile ? slide + 189 : slide + 250,
        slideIndex: slideIndex - 1,
      });
    }

    console.log(slide, slideIndex);
  };
  _move = (part) => {
    console.log(part);

    const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

    // const today ='2022-12-07 00:00:00'

    if (part === '1차 예선') {
      if (today >= '2025-11-19 16:00:00') {
        window.open(`${this.voteUrl}/2025/pre/round-1`, 'aketo', '');
        // window.open(
        //   'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=128&event_id=11',
        //   'aketo',
        //   ''
        // );
      } else {
        alert('1차 예선은 11월 19일 오후 4시에 시작됩니다.');
      }
    } else if (part === '2차 예선') {
      if (today >= '2025-11-26 16:00:00') {
        window.open(`${this.voteUrl}/2025/pre/round-2`, 'aketo', '');
        // window.open(
        //   'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=129&event_id=11',
        //   'aketo',
        //   ''
        // );
      } else {
        alert('2차 예선은 11월 26일 오후 4시에 시작됩니다.');
      }
    } else if (part === '32강') {
      if (today >= '2025-12-03 16:00:00') {
        window.open(`${this.voteUrl}/2025/tournament/round-32`, 'aketo', '');
        // window.open(
        //   'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=130&event_id=11',
        //   'aketo',
        //   ''
        // );
      } else {
        alert('32강은 12월 03일 오후 4시에 시작됩니다.');
      }
    } else if (part === '16강') {
      if (today >= '2025-12-10 16:00:00') {
        window.open(`${this.voteUrl}/2025/tournament/round-16`, 'aketo', '');
        // window.open(
        //   'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=131&event_id=11',
        //   'aketo',
        //   ''
        // );
      } else {
        alert('16강은 12월 10일 오후 4시에 시작됩니다.');
      }
    } else if (part === '8강') {
      if (today >= '2025-12-17 16:00:00') {
        window.open(`${this.voteUrl}/2025/tournament/round-8`, 'aketo', '');
        // window.open(
        //   'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=132&event_id=11',
        //   'aketo',
        //   ''
        // );
      } else {
        alert('8강은 12월 17일 오후 4시에 시작됩니다.');
      }
    } else if (part === '4강') {
      if (today >= '2025-12-22 18:00:00') {
        window.open(`${this.voteUrl}/2025/tournament/round-4`, 'aketo', '');
        // window.open(
        //   'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=133&event_id=11',
        //   'aketo',
        //   ''
        // );
      } else {
        alert('4강은 12월 22일 오후 6시에 시작됩니다.');
      }
    } else if (part === '3, 4위전') {
      if (today >= '2025-12-26 18:00:00') {
        window.open(`${this.voteUrl}/2025/tournament/final`, 'aketo', '');
        // window.open(
        //   'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=134&event_id=11',
        //   'aketo',
        //   ''
        // );
      } else {
        alert('3, 4위전은 12월 26일 오후 6시에 시작됩니다.');
      }
    } else if (part === '결승전') {
      if (today >= '2025-12-26 18:00:00') {
        window.open(`${this.voteUrl}/2025/tournament/final`, 'aketo', '');
        // window.open(
        //   'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=134&event_id=11',
        //   'aketo',
        //   ''
        // );
      } else {
        alert('결승전은 12월 26일 오후 6시에 시작됩니다.');
      }
    }
  };

  _renderItem = () => {
    const { voteList, slide } = this.state;

    const list = voteList.map((item, index) => {
      return (
        <div
          key={index}
          className={
            item.button === '투표하기'
              ? 'on'
              : item.button === '결과보기'
              ? 'off'
              : 'off'
          }
          style={{
            transform: `translateX(${slide}px)`,
            transition: '0.5s ease',
          }}
        >
          <div className="tit">{item.part}</div>
          <div className="date">{item.dateTitle}</div>
          <div className="info">
            {item.title}
            <br />
            {item.title1}
          </div>
          <button type="button" onClick={() => this._move(item.part)}>
            {item.button}
          </button>
        </div>
      );
    });

    return list;
  };
  render() {
    const { voteList } = this.state;
    //console.log(slide, slideIndex)
    return (
      <div className="schdule_wrap">
        <div className="schdule_inner">
          <div className="schdule">{voteList ? this._renderItem() : null}</div>
        </div>

        <a
          style={{ cursor: 'pointer' }}
          className="arrw prev"
          onClick={this._onPrev}
        >
          이전
        </a>
        <a
          style={{ cursor: 'pointer' }}
          className="arrw next"
          onClick={this._onNext}
        >
          다음
        </a>
      </div>
    );
  }
}

export default shopContext(withRouter(VoteSch2025));
